<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form ref="form" lazy-validation style="height: calc(100% - 64px)">
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0">
          <v-list-item-title>ส่งประกาศ</v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div style="height: calc(100% - 128px)">
        <div class="px-4 py-4">
          <label class="body-2">
            ประเภทการส่งประกาศ
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            v-model="typeSendAnnouncement"
            :items="[
              // {
              //   label: 'ทั้งหมด',
              //   value: 'all',
              // },
              {
                label: 'หน่วยงาน',
                value: 'organization',
              },
              {
                label: 'พนักงาน',
                value: 'employee',
              },
            ]"
            :rules="[(v) => !!v || 'โปรดระบุประเภทการส่งประกาศ']"
            item-text="label"
            item-value="value"
            outlined
            dense
            clearable
            @change="handleSelectedAddEmployeeType($event)"
          >
          </v-autocomplete>
        </div>
        <div class="mx-4" style="height: 100%">
          <CardAnnouncementEmployees
            v-if="typeSendAnnouncement === 'employee'"
            :selectedEmployees="selectedEmployees"
            @onClickBlack="handleClickBack"
            @onCheckEmployee="handleCheckEmployee"
            @onCheckAllEmployee="handleCheckAllEmployee"
            @onClearEmployees="selectedEmployees = []"
            @onClearCheckAllEmployee="checkedAllEmployee = null"
          />
          <CardOrganizationTree
            v-if="typeSendAnnouncement === 'organization'"
            @onClickBlack="handleClickBack"
            @onCheckOrganization="handleCheckOrganization"
          />
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <div style="display: none">
            {{ isAnnouncementSendFormDataChange }}
          </div>
          <v-btn
            class="primary"
            depressed
            :disabled="
              (!selectedEmployees.length &&
                !selectedOrganizations.length &&
                checkedAllEmployee === null) ||
              (uiCtrl && !uiCtrl.isEnable('btn:::announcement:send'))
            "
            @click="onSend"
          >
            ส่งประกาศ
          </v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import CardAnnouncementEmployees from '@/components/CardAnnouncementEmployees.vue'
import CardOrganizationTree from '@/components/CardOrganizationTree.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    CardAnnouncementEmployees,
    CardOrganizationTree,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    announcement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogForbidden: false,
      typeSendAnnouncement: null,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      selectedEmployees: [],
      selectedOrganizations: [],
      checkedAllEmployee: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isAnnouncementSendFormDataChange() {
      if (this.typeSendAnnouncement) {
        this.$emit('isAnnouncementSendFormDataChange', true)
        return true
      }
      this.$emit('isAnnouncementSendFormDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      sendAnnouncement: 'announcement/sendAnnouncement',
      fetchAnnouncements: 'announcement/fetchAnnouncements',
    }),
    handleSelectedAddEmployeeType(value) {
      this.checkedAllEmployee = null
      this.selectedEmployees = []
    },
    handleCheckEmployee(value, employee) {
      this.selectedEmployees = value
        ? [...this.selectedEmployees, { ...employee }]
        : this.selectedEmployees.filter(
            (item) => item.employee_uuid !== employee.employee_uuid
          )
    },
    handleCheckAllEmployee(value, employee) {
      if (value) {
        this.checkedAllEmployee = employee
        this.selectedEmployees = []
      } else {
        this.checkedAllEmployee = null
      }
    },
    handleCheckOrganization(organizations) {
      this.selectedOrganizations = organizations.map(
        (org) => org.organization_uuid
      )
    },
    async onSend() {
      try {
        const now = moment().format('DD/MM/YYYY HH:mm')
        const expiredDatetime = this.announcement.expired_datetime
          ? this.announcement.expired_datetime
          : null

        if (expiredDatetime < now) {
          const snackbar = {
            show: true,
            color: 'warning',
            timeout: 4000,
            message: 'ไม่สามารถส่งประกาศที่หมดอายุแล้ว',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          return
        }

        if (this.typeSendAnnouncement === 'organization') {
          if (this.selectedOrganizations.length === 0) {
            const snackbar = {
              show: true,
              color: 'warning',
              timeout: 4000,
              message: 'กรุณาเลือกหน่วยงานอย่างน้อย 1 หน่วยงาน',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            return
          }
        }

        if (this.typeSendAnnouncement === 'employee') {
          if (this.selectedEmployees.length === 0 && !this.checkedAllEmployee) {
            const snackbar = {
              show: true,
              color: 'warning',
              timeout: 4000,
              message: 'กรุณาเลือกพนักงานอย่างน้อย 1 คน',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            return
          }
        }

        const payload = {
          company_uuid: this.$store.state.authentication.company.company_uuid,
          announcement_uuid: this.announcement.announcement_uuid,
          body: {
            include_all: this.checkedAllEmployee ? true : false,
            organization_uuids:
              this.typeSendAnnouncement === 'organization'
                ? this.selectedOrganizations
                : null,
            employee_uuids:
              this.typeSendAnnouncement === 'employee'
                ? this.selectedEmployees.map(
                    (employee) => employee.employee_uuid
                  )
                : null,
          },
        }

        this.$store.state.loading = true

        await this.sendAnnouncement(payload)

        this.$store.commit('announcement/SET_IS_CREATED_ANNOUNCEMENT', false)

        await this.fetchAnnouncements({
          company_uuid: this.$store.state.authentication.company.company_uuid,
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 4000,
          message: 'ส่งประกาศสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.typeSendAnnouncement = null

        this.$emit('handleSendAnnouncementCompleted')
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    handleClickBack() {
      if (this.typeSendAnnouncement) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('onClickBlack')
        this.typeSendAnnouncement = null
        this.selectedEmployees = []
        this.$refs.form.resetValidation()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('onClickBlack')
      this.typeSendAnnouncement = null
      this.selectedEmployees = []
      this.$refs.form.resetValidation()
    },
  },
}
</script>
